import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

export default {
  get(params?: cyrian.api.search.Params): ApiResponse<WrappedResult<cyrian.api.search.ResponseItem[]>> {
    return request({
      method: 'get',
      url: '/search',
      headers: {
        'Content-Type': 'application/json',
      },
      params,
    });
  },
};
